export const CALL_HISTORY_API = 'CALL_HISTORY_API'
export const CALL_HISTORY_API_FAILED = 'CALL_HISTORY_API_FAILED'
export const CALL_HISTORY_FILTERS_API = 'CALL_HISTORY_FILTERS_API'
export const CALL_HISTORY_FILTERS_API_FAILED = 'CALL_HISTORY_FILTERS_API_FAILED'
